import styled from "@emotion/styled";

export const StyledMedicalSection = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.settingsColor};
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`;
export const StyledMedicalSectionHeader = styled.h3`
  font-weight: 200;
  color: ${({ theme }) => theme.colors.main[9]};
  margin: 0;
`;

export const StyledMedicalContentLabel = styled.p`
  font-weight: 200;
  color: ${({ theme }) => theme.colors.text};
`;

export const StyledMedicalContent = styled.div`
  display: flex;
  gap: 5px;
`;
